export default {
  CHL_MGMT_LIST_REQUEST: 'APP/CHL_MGMT/CHL_MGMT_LIST_REQUEST',
  CHL_MGMT_LIST_SUCCESS: 'APP/CHL_MGMT/CHL_MGMT_LIST_SUCCESS',
  CHL_MGMT_LIST_ERROR: 'APP/CHL_MGMT/CHL_MGMT_LIST_ERROR',

  CHL_INFO_REQUEST: 'APP/CHL_INFO/CHL_INFO_REQUEST',
  CHL_INFO_SUCCESS: 'APP/CHL_INFO/CHL_INFO_SUCCESS',
  CHL_INFO_ERROR: 'APP/CHL_INFO/CHL_INFO_ERROR',
};
